import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface SerialNumberModel {
  title: string;
  item: any;
}
@Component({
  selector: 'app-serialnumberlist',
  templateUrl: './serialnumberlist.component.html',
  styleUrls: ['./serialnumberlist.component.css']
})
export class SerialNumberListComponent extends DialogComponent<SerialNumberModel, boolean>
  implements SerialNumberModel, OnInit {
  constructor(
    dialogService: DialogService,
    private pos: PosService
  ) {
    super(dialogService);
  }

  title: string;
  item: any;
  result: any = { result: false, RtnItem: {} };
  SerialNoList: any = [];
  SerialNumberList: any = [];
  SerialNoAllList: any = [];
  itemCount: number = 0;
  cols: any[];

  ngOnInit() {
    this.getSerialNumberByBarcode();

    this.cols = [
      { field: 'SlNo', header: 'SlNo.', t: 'text', f: 'text', w: "80px", Align: 'left' },
      { field: 'SerialNo', header: 'Serial Number', t: 'text', f: 'input', w: "200px", Align: 'left' }
    ];

    if (this.item.SerialNumberList.length > 0) {
      this.itemCount = Number(Math.abs(this.item.Qty));
      this.SerialNumberList = this.item.SerialNumberList;
    }

  }

  getSerialNumberByBarcode() {
    var data = {
      Barcode: this.item.Barcode,
      LocId: this.item.LocId
    }

    this.SerialNoList = [];
    this.SerialNoAllList = [];
    this.pos.getSerialNumberByBarcode(data).subscribe(res => {
      if (res.Success) {
        for (let i of res.data) {
          if (i.Qty > 0) {
            this.SerialNoList.push(i);
          }
          this.SerialNoAllList.push(i);
        }
        document.getElementById('SerialNo1').focus();
      }
      else {
        this.SerialNoList = [];
        this.SerialNoAllList = [];
      }
    })
  }

  validateSave(): boolean {
    if (this.itemCount != this.SerialNumberList.length) {
      alert("TotalS quantity(" + this.itemCount + ") and serial numbers not matching");
      return false;
    }
    if(Number(this.item.Qty)< 0){
      for (let i of this.SerialNumberList) {
        if (i.SerialNo == "") {
          alert("Please enter Serial Number");
          return false;
        }
      }
    }
    else{
      for (let i of this.SerialNumberList) {
        if (i.SerialNo == "") {
          alert("Please enter Serial Number");
          return false;
        }
  
        var slno = this.SerialNoList.find(c => c.SerialNo == i.SerialNo )
        if (!slno) {
          alert("Serial No.("+i.SerialNo+") invalid or already used");
          return false
        }
        
        var Bcount = this.SerialNoList.find(x => x.SerialNo == i.SerialNo).Qty;
        var Scount = this.SerialNumberList.filter(x => x.SerialNo == i.SerialNo).length;
  
        if (Bcount < Scount) {
          alert("Please enter valid Serial No. (" + i.SerialNo + ") for row " + i.SlNo);
          return false;
        }
      }
    }
    return true;
  }

  // SLNOKeyDown(e){
  //   if (e.keyCode == 13 && e.which == 13) {
  //     if (this.validateSave()) {

  //       this.result.result = true;
  //       this.result.RtnItem = this.SerialNumber;
  //       this.close();
  //     }
  //   }
  // }


  SerialNoKeydown(e, n, d) {
    if (e.keyCode == 13 && e.which == 13) {

      if(Number(this.item.Qty)< 0){
        if (d == undefined || d == "") {
          alert("Please enter valid Serial No.");
          return
        }
      }
      else{
        if (d != undefined && d != "") {
          var slno = this.SerialNoList.find(c => c.SerialNo == d)
          if (!slno) {
            alert("Serial No. invalid or already used");
            return
          }
        }
        else {
          alert("Please enter valid Serial No.");
          return
        }
  
        var Bcount = this.SerialNoList.find(x => x.SerialNo == d).Qty;
        var Scount = this.SerialNumberList.filter(x => x.SerialNo == d).length;
  
        if (Bcount < Scount) {
          alert("Please enter valid Serial No.");
          return 
        }
      }
      if (this.SerialNumberList.length >= n + 1) {
        var key = "SerialNo" + Number(n + 1).toString()
        document.getElementById(key).focus();

      }
    }
  }

  saveNumber() {
    if (this.validateSave()) {
      var txt = "";
      for (let i of this.SerialNumberList) {
        if (i.SerialNo == "") {
          continue;
        }
        txt = txt + i.SerialNo + ",";
      }
      txt = txt.replace(/,\s*$/, "");

      this.result.result = true;
      this.result.RtnItem = txt;
      this.close();
    }
  }

}
